import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {LOAI_DON_THUOC, tabKeys} from "types/enums";
import {medicineStoreService} from "api";

export interface State {
  selectedRecord: any;
  detailRecord: any;
  searchForm: any;
  activeTabPresciption: string;
  typePrescription: LOAI_DON_THUOC;
  showHoanLai: boolean;
  salePrescription: any;
  listLoOfName: any[];
  listUnitOfThuocId: any[];
  loading: boolean;
  reduceRef: any;
  expandRef: any;
  enableSLHoanTra: boolean;
  listPatient: any[];
}

const initialState: State = {
  selectedRecord: null,
  detailRecord: null,
  searchForm: null,
  showHoanLai: false,
  activeTabPresciption: tabKeys.MEDICINE_STORE.LIST_1,
  typePrescription: null,
  salePrescription: null,
  listLoOfName: [],
  listUnitOfThuocId: [],
  loading: false,
  reduceRef: null,
  expandRef: null,
  enableSLHoanTra: false,
  listPatient: [],
};

export const medicineStoreSlice = createSlice({
  name: "medicineStore",
  initialState: initialState,
  reducers: {
    setSelectedRecord: (state = initialState, action: PayloadAction<any>) => {
      return {...state, selectedRecord: action.payload};
    },
    setDetailRecord: (state = initialState, action: PayloadAction<any>) => {
      return {...state, detailRecord: action.payload};
    },
    setSearchForm: (state = initialState, action: PayloadAction<any>) => {
      return {...state, searchForm: action.payload};
    },
    setTypePrescription: (state = initialState, action: PayloadAction<any>) => {
      return {...state, typePrescription: action.payload};
    },
    setActiveTabPresciption: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return {...state, activeTabPresciption: action.payload};
    },
    setSalePrescription: (state = initialState, action: PayloadAction<any>) => {
      return {...state, salePrescription: action.payload};
    },
    setListLoOfName: (state = initialState, action: PayloadAction<any>) => {
      return {...state, listLoOfName: [...state.listLoOfName, action.payload]};
    },
    setListUnitOfThuocId: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return {
        ...state,
        listUnitOfThuocId: [...state.listUnitOfThuocId, action.payload],
      };
    },
    setLoading: (state = initialState, action: PayloadAction<any>) => {
      return {...state, loading: action.payload};
    },
    setReduceRef: (state = initialState, action: PayloadAction<any>) => {
      return {...state, reduceRef: action.payload};
    },
    setExpandRef: (state = initialState, action: PayloadAction<any>) => {
      return {...state, expandRef: action.payload};
    },
    setEnableSLHoanTra: (state = initialState, action: PayloadAction<any>) => {
      return {...state, enableSLHoanTra: action.payload};
    },
    setListPatient: (state = initialState, action: PayloadAction<any>) => {
      return {...state, listPatient: action.payload};
    },
    setShowHoanLai: (state = initialState, action: PayloadAction<any>) => {
      return {...state, showHoanLai: action.payload};
    },
  },
});

export const {
  setSelectedRecord,
  setDetailRecord,
  setSearchForm,
  setActiveTabPresciption,
  setTypePrescription,
  setSalePrescription,
  setListLoOfName,
  setListUnitOfThuocId,
  setLoading,
  setReduceRef,
  setExpandRef,
  setEnableSLHoanTra,
  setListPatient,
  setShowHoanLai,
} = medicineStoreSlice.actions;

export default medicineStoreSlice.reducer;

export const getListPatientAPI = name => {
  return async dispatch => {
    try {
      const listPatient =
        (await medicineStoreService.getListPatient(name)) || [];
      dispatch(setListPatient(listPatient));
    } catch (error) {}
  };
};
